export default "__VITE_ASSET__Bic49dhC__"